import { LoginClient, LoginRequest } from '../../swagger/putujmoAdminService';


export const loginAction = (loginRequest: LoginRequest ) => {
	const client = new LoginClient();
	return client.login(loginRequest);
}
